import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from "react";
import { Route, Switch } from 'react-router-dom'
import { Container } from 'react-bootstrap';

// AD Stuff
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";

//Multimedia
import Image from "./images/logo_afp.png";

//Componentes
import Footer from './components/Footer'
import NavBar from './components/NavBar';
import NavBarEjecutivo from './components/NavBarEjecutivo'
import NavBarSupervisor from './components/NavBarSupervisor'


//Sitios
import Numerificador from './pages/Numerificador';
import Mantenedor from './pages/Mantenedor';
import HomeNoAccess from './pages/HomeNoAccess';
import Home from './pages/Home';
// import Carga from './pages/Carga';
import apiService from './services/api'



function App() {
  return (
    <div className="App bg">
      <UnauthenticatedTemplate>
        <NavBar />
        <div className='main-content'>
          <Switch>
            <Route excat path='/' component={Home} />
          </Switch>
        </div>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <AuthenticateUser />
      </AuthenticatedTemplate>
      <Footer><img
        alt=""
        src={Image}
        width="5%"
        className="d-inline-block align-top text-center"
      />   Desarrollado por Zenith</Footer>
    </div>
  );
}

const AdminView = () => {
  return (
    <div>
      <NavBarSupervisor />
      <div className='main-content '>
        <Container className='containerBG'>
          <Switch>
            <Route path='/mantenedor' component={Mantenedor} />
            {/* <Route path='/carga' component={Carga} /> */}
            <Route excat path='/' component={Numerificador} />
          </Switch>
        </Container>
      </div>
    </div>
  )
}

const AgentView = () => {
  return (
    <div>
      <NavBarEjecutivo />
      <div className='main-content' >
        <Container className='containerBG'>
          <Switch>
            <Route excat path='/' component={Numerificador} />
          </Switch>
        </Container>
      </div>
    </div>
  )
}

const NoAccessView = () => {
  <div>
    <NavBar />
    <div className='main-content'>
      <Container className='containerBG'>
        <Switch>
          <Route excat path='/' component={HomeNoAccess} />
        </Switch>
      </Container>
    </div>
  </div>
}


const AuthenticateUser = () => {
  const { accounts, instance } = useMsal(); // Agregamos 'instance' para obtener la instancia MSAL
  // 1 -> SAdmin 2 -> ejecutivo 0 -> null o  no Acceso
  const [userData, setUserData] = useState({ state: false, rol: 0, usuario: undefined })

  let user = accounts[0] && accounts[0].idTokenClaims ? accounts[0].idTokenClaims.preferred_username : ""

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        // Inicializar apiService con la instancia de MSAL
        // Esto permite al servicio obtener tokens de acceso automáticamente
        apiService.setMsalInstance(instance);

        const response = await apiService.searchUser(user.toLowerCase());
        
        if (response.res && response.data.rol && response.data.estado === 1) {
          setUserData({ state: true, rol: response.data.rol, usuario: response.data.usuario })
        } else {
          setUserData({ state: false, rol: response.data.rol, usuario: response.data.usuario })
        }
      } catch (error) {
        console.error(`Error al autenticar usuario - ${user}:`, error.message)
        
        // Si el token expiró o requiere re-autenticación
        if (error.needsLogin) {
          console.warn('⚠️ Sesión expirada. Redirigiendo al login...');
          
          // Hacer logout para limpiar el estado
          instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin
          }).catch(logoutError => {
            console.error('Error en logout:', logoutError);
            // Si el logout falla, al menos limpiamos el cache
            instance.clearCache();
            window.location.href = '/';
          });
          
          return; // Detener ejecución
        }
        
        setUserData({ state: false, rol: "No-Encontrado-En-BD", usuario: user })
      }
    }

    authenticateUser()
  }, [user, instance]); // Agregamos 'instance' como dependencia

  if (userData.state) {
    switch (userData.rol) {
      case "admin": // Sadmin
        return <AdminView />

      case "agent": //ejcutivo
        return <AgentView />

      default: // NoAccess
        return <NoAccessView />
    }
  } else {
    return <NoAccessView />
  }

}

export default App;
